const getTeamData = state => {
  if (!state.TeamReducer.teams) {
    return [];
  }

  return state.TeamReducer.teams;
};

const getTeamLoading = state => {
  return state.TeamReducer.loading.teams;
};

const getTeamError = state => {
  return state.TeamReducer.error.teams;
};

const isLoading = state => {
  return getTeamLoading(state);
};

export const TeamSelector = {
  getTeamData,
  getTeamLoading,
  getTeamError,
  isLoading,
};
